<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

// Select all badges with the class 'custom-badge'
function addBadgeClasses() {
  const badges = document.querySelectorAll('.custom-badge');
  badges.forEach(badge => {
    if (!badge.dataset.classAdded) { // avoid adding twice
      const textClass = badge.textContent.trim().toLowerCase().replace(/\s+/g, '');
      badge.classList.add(textClass);
      badge.dataset.classAdded = "true";
    }
  });
}

// Initial run
addBadgeClasses();

// Watch for new badges added dynamically
const observer = new MutationObserver(() => {
  addBadgeClasses();
});

observer.observe(document.body, { childList: true, subtree: true });


